import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { timeElapsedBeforeNextAccessPrompt } from 'config/spotifyConfig';

const Redirection = ({ user, location }) => {
  const { redirectTo } = location;

  if (!user.uid) {
    return (
      <h3
        style={{
          textAlign: 'center',
          marginTop: '300px',
        }}
      >
        Loading Your Data...
      </h3>
    );
  }

  const { on, status } = user.spotifyAuth || {};

  // User denied access
  if (isEmpty(user.socialAccounts)) {
    return <Redirect to='/social-accounts' />;
  }
  if (!user.favoriteGenres.length) {
    return <Redirect to='/pick-genres' />;
  }
  // Show spotify prompt if access denied more than 24 hours ago
  if (
    !status ||
    (status === 'denied' && Date.now() - on > timeElapsedBeforeNextAccessPrompt)
  ) {
    return <Redirect to='/allow-spotify-access' />;
  }
  if (
    redirectTo &&
    redirectTo !== '/pages/login-page' &&
    redirectTo !== '/redirect' &&
    redirectTo !== '/pages/login-page' &&
    redirectTo !== '/'
  ) {
    return <Redirect to={redirectTo} />;
  }
  return <Redirect to='/profile' />;
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps)(Redirection);
